import React, { Component, useContext, useRef } from "react";
import "./Navbar.scss";
import { NavLink, useHistory, withRouter } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import logo_dark from "../../assets/images/logo_dark.png";
import Scrollbars from "react-custom-scrollbars";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../helper/context";
import { closeIcon, searchIcon, transparentInfoIcon } from "../../helper/icons";
import Scroller from "../Scroller/ScrollBar";
import { encryptStorage, timeAgo } from "../../helper/storage";
import { API_URL, axiosApiInstance } from "../../helper/request";
import Loading from "../Loading/Loading";
import axios from "axios";
import Button from "../Button/Button";
import AnimatedModal from "../Modal/AnimatedModal";
import InputBox from "../Inputbox/InputBox";
import { notify } from "../../Routes";
import Dropdown from "../Dropdown/Dropdown";
import ManufacturerModal from "../DeveloperModal/ManufacturerModal ";
// import inventoryIconSvg from "../../assets/images/inventory.svg"

class ChildComp extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.primaryRef = React.createRef();
    this.ldata = encryptStorage.getItem("UID");
  }
  state = {
    theme: "Light",
    themeTooltip: "Dark Theme",
    userType: ["user", "manufacturer"],
    links: [
      {
        page: "/home",
        icon: homeicon(),
        name: "HOME",
      },
      {
        page: "/device",
        icon: deviceIcon(),
        name: "Devices",
      },
      {
        page: "/users",
        icon: userIcon(),
        name: "Users",
      },
    ],
    userRoleLink: {
      user: ["home", "device", "inventory", "apps"],
      manufacturer: ["home", "device", "users", "apps", "license", "inventory"],
      developer: ["home", "device", "apps"],
      superadmin: ["home", "device", "apps", "users"],
      moderator: ["home", "device", "apps"],
    },
    showOptionList: false,
    showNotification: false,
    showRequest: false,
    LoadingScreen: false,
    RequestData: [],
    Message: "",
    MessageModal: false,
    CompanyName: "",
    Bank: {},
    Name: "",
    Country: "",
  };

  handleScroll = () => {
    this.myRef.scrollToBottom();
  };

  handleFocus = (name) => {
    let ele = document.getElementById(name);
    ele.classList.remove("error_shake", "input__error");
  };

  renderElement = (item, idx) => {
    switch (item.type) {
      case "string":
      case "number":
        return (
          <InputBox
            id={item.name}
            header={item.name.replace(/_/g, " ")}
            onChange={(e) => {
              const value =
                item.type === "string"
                  ? e.target.value
                  : e.target.value.replace(/[^0-9]/g, "");
              this.handleChanges(value, idx);
            }}
            value={item.value}
            onFocus={() => this.handleFocus(item.name)}
          />
        );
      case "dropdown":
        return (
          <Dropdown
            label={item.name.replace(/_/g, " ")}
            className="adjust_dd"
            id={item.name}
            optionsList={item.options}
            handleOption={(data) => {
              this.handleChanges(data, idx);
              this.handleFocus(item.name);
              // setAccountType(data);
            }}
            defaultText={item.value}
            // error={BankError["isAccountTypeEmpty"]}
          />
        );
      default:
        return <p> NO ELEMENT FOUND</p>;
    }
  };

  validateBankData = () => {
    let res = false;
    for (let i = 0; i < this.state.Bank.fields.length; i++) {
      if (this.state.Bank.fields[i].required) {
        if (!this.state.Bank.fields[i].value) {
          let ele = document.getElementById(this.state.Bank.fields[i].name);
          ele.classList.add("error_shake", "input__error");
          res = true;
        }
      }
    }
    return res;
  };

  //superadmin MANUFACTURER REQUEST post
  postRequest = (status, username) => {
    axiosApiInstance
      .post("user/superadmin/requests", {
        username,
        status,
      })
      .then((res) => {
        this.props.themeContext.getRequest();
        notify({
          msg: "Request accepted",
          type: "success",
        });
      })
      .catch((err) => {
        notify({
          msg: "Server Error",
          type: "error",
        });
      });
  };

  //NOTIFICATION REQUEST post

  postReject = () => {
    this.setState({ LoadingScreen: true, showNotification: false });
    axiosApiInstance
      .post("user/invite/manufacturer/accept", {
        status: "rejected",
      })
      .then((res) => {
        this.props.themeContext.getNotification();
        notify({
          msg: "Request to become a manufacturer rejected!",
          type: "success",
        });
      })
      .catch((err) => {
        notify({
          msg: "Failed to send manufacturer data!",
          type: "alert",
        });
      })
      .finally(() => {
        this.setState({ LoadingScreen: false });
      });
  };

  changeTheme = () => {
    const html = document.querySelector("html");
    if (this.state.theme === "Dark") {
      localStorage.setItem("theme", "Light");
      this.props.themeContext.setTheme("Light");
      this.setState({ theme: "Light" }, () => {
        this.props.handleThemeChange &&
          this.props.handleThemeChange(this.state.theme);
      });
      html.classList.add("light-theme");
      html.classList.remove("dark-theme");
      this.setState({ themeTooltip: "Dark Theme" });
    } else {
      this.setState({ theme: "Dark" }, () => {
        this.props.themeContext.setTheme("Dark");

        this.props.handleThemeChange &&
          this.props.handleThemeChange(this.state.theme);
      });
      localStorage.setItem("theme", "Dark");
      html.classList.add("dark-theme");
      html.classList.remove("light-theme");
      this.setState({ themeTooltip: "Light Theme" });
    }
  };

  componentDidMount() {
    const html = document.querySelector("html");
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", "Light");
      this.setState({ theme: "Light" });
      html.classList.add("light-theme");
      html.classList.remove("dark-theme");
    } else {
      this.setState({ theme: localStorage.getItem("theme") }, () => {
        if (this.state.theme === "Dark") {
          html.classList.add("dark-theme");
          html.classList.remove("light-theme");
        } else {
          html.classList.add("light-theme");
          html.classList.remove("dark-theme");
        }
      });
    }
    if (this.props.handleScroll) {
      this.props.handleScroll(this.handleScroll);
    }
    // document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    // document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.handleScroll) {
      this.props.handleScroll(this.handleScroll);
    }
  }

  handleClickOutside = (event) => {
    if (!this.primaryRef?.current?.contains(event.target)) {
      this.setState({ showNotification: false });
    }
  };

  switchNotification = (item, idx) => {
    let notifacationHeader = {
      manufacturer_invite: "New Request",
      product_issue: "New Issue",
      message: "New Message",
      rating: "New Rating",
    };
    const renderData = (item) => (
      <div className="msg">
        <div style={{ marginTop: "0.5vw" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              opacity: "0.5",
            }}
          >
            <p>{notifacationHeader[item.action_type]}</p>
            <p>{item.time}</p>
          </div>
          <p className="noti_data">
            {item.data.length > 50
              ? item.data.substring(0, 50) + "..."
              : item.data}
          </p>
        </div>
      </div>
    );

    switch (item.action_type) {
      case "message":
        return (
          <div className="notification__card">
            {bellIcon()}
            {renderData(item)}
          </div>
        );
      case "product_issue":
        return (
          <div className="notification__card">
            {emailIcon()}
            {renderData(item)}
          </div>
        );
      case "rating":
        return (
          <div className="notification__card">
            {starIcon()}
            {renderData(item)}
          </div>
        );
      case "manufacturer_invite":
        return (
          <div className="notification__card">
            {requestIcon2()}
            <div
              className="msg"
              onMouseEnter={() => {
                document.getElementById("request_" + idx).style.maxHeight =
                  "1000px";
              }}
              onMouseLeave={() => {
                document.getElementById("request_" + idx).style.maxHeight = "0";
              }}
            >
              <div style={{ marginTop: "0.5vw" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    opacity: "0.5",
                  }}
                >
                  <p>{notifacationHeader[item.action_type]}</p>
                  <p>{timeAgo(item.created)}</p>
                </div>
                <p className="noti_data">
                  {item.action_data.parent_manufacturer_username + " "} has
                  invited you to become a manufacturer.{" "}
                </p>

                <Button
                  name="Accept"
                  // onClick={() => {
                  //   this.setState({
                  //     LoadingScreen: true,
                  //     showNotification: false,
                  //   });
                  // }}
                  onClick={() =>
                    this.setState({
                      MessageModal: true,
                      showNotification: false,
                    })
                  }
                  type="gradient"
                />
                <Button
                  name="Reject"
                  onClick={this.postReject}
                  style={{
                    marginLeft: "01vw",
                    background: "#b9bec9",
                  }}
                />
                <div id={"request_" + idx} className="message__">
                  <p>{item.action_data.message}</p>
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  renderNotification = () => {
    return this.props.themeContext.Notification.map((item, idx) =>
      this.switchNotification(item, idx)
    );
  };

  renderLink = (type) => {
    const Nav = (link, icon, name) => (
      <NavLink to={link} activeClassName="activated_tab">
        <div className="navbar_verticle_tab">
          {icon()}
          <span className="navbar_verticle_name">{name}</span>
        </div>
      </NavLink>
    );
    switch (type) {
      case "home":
        return Nav("/home", homeicon, "Home");

      case "device":
        return Nav("/device", deviceIcon, "Devices");

      case "users":
        return Nav("/users", userIcon, "Users");

      // case "usecases":
      //   return Nav("/usecases", usecaseIcon, "Usecases");

      case "apps":
        return Nav("/apps", appsIcon, "Apps");

      case "license":
        return Nav("/license", licenseIcon, "License");

      case "inventory":
        return Nav("/inventory", inventoryIcon, "Inventory");
      case "mgf":
        return Nav("/users", userIcon, "Manufacturer");
      default:
        Nav("/home", homeicon, "Home");
    }
  };

  switchRole = (value) => {
    this.setState({ LoadingScreen: true });
    axios
      .post(
        API_URL + "auth/switch",
        {},
        {
          headers: {
            userType: value,
            Authorization: "Bearer " + this.ldata.refreshToken,
          },
        }
      )
      .then((res) => {
        let _data = encryptStorage.getItem("UID");
        _data.current = value;
        let { accessToken, refreshToken } = res.data;
        _data = { ..._data, accessToken, refreshToken };
        this.props.themeContext.setRole({
          ...this.props.themeContext.Role,
          current: value,
        });
        encryptStorage.setItem("UID", _data);
        this.props.history.push("/");
        //  this.props.themeContext
      })
      .catch(() => {
        alert("Failed to Switch");
      })
      .finally(() => {
        this.setState({ LoadingScreen: false });
      });
  };

  logout = () => {
    let refreshToken = encryptStorage.getItem("UID").refreshToken;
    this.setState({ LoadingScreen: true });
    axios
      .post(
        API_URL + "auth/logout",
        {},
        {
          headers: {
            Authorization: "Bearer " + refreshToken,
          },
        }
      )
      .then((res) => {
        encryptStorage.removeItem("UID");
        this.props.themeContext.setRole({
          current: null,
          all: null,
        });
        this.props.history.push("/");
      })
      .catch((err) => {
        alert("failed to logout!");
      })
      .finally(() => {
        this.setState({ LoadingScreen: false });
      });
  };

  setLoadingScreen = (value) => this.setState({ LoadingScreen: value });
  setManufModal = () => this.setState({ MessageModal: false });
  render() {
    const {
      showOptionList,
      userRoleLink,
      LoadingScreen,
      Message,
      MessageModal,
      CompanyName,
    } = this.state;
    return (
      <React.Fragment>
        <ReactTooltip delayShow={200} />
        {/* {this.state.sound && (
          <audio
            src="https://notificationsounds.com/storage/sounds/file-sounds-1148-juntos.mp3"
            id="notification"
            style={{ display: "none" }}
          />
        )} */}

        <div
          className="navbar_root"
          onClick={() => {
            if (this.state.showOptionList) {
              this.setState({ showOptionList: false });
            }
            if (this.state.showRequest) {
              this.setState({ showRequest: false });
            }
          }}
        >
          <div
            className="nav_header"
            onClick={() =>
              this.setState({ showNotification: false, showRequest: false })
            }
          >
            <header className="navbar_horizontal">
              <div className="navbar_logo">
                <NavLink to={"/home"}>
                  {this.state.theme === "Light" ? (
                    <img
                      className="navbar_logo_img"
                      src={logo}
                      alt="rdx-logo"
                    />
                  ) : (
                    <img
                      className="navbar_logo_img"
                      src={logo_dark}
                      alt="rdx-logo"
                    />
                  )}
                </NavLink>
                {this.props.search && (
                  <div className="nav_search_wrapper">
                    {searchIcon()}
                    <input
                      placeholder="search"
                      type={"search"}
                      className="nav_search_input"
                    />
                  </div>
                )}
              </div>
              <div className="nav_userInfo">
                {this.props.themeContext?.Role?.current === "user" && (
                  <div
                    className="nav_cart_info"
                    onClick={() => {
                      this.props.history.push("/cart");
                    }}
                  >
                    {cartIcon()}
                    <div className="cart-count">
                      {this.props.themeContext?.Cart?.length}
                    </div>
                  </div>
                )}
                {this.props.themeContext.Role.current === "superadmin" && (
                  <div
                    className="nav_request_info"
                    style={{ margin: "0 1vw", marginRight: "0.5vw" }}
                  >
                    {requestIcon((e) => {
                      e.stopPropagation();
                      this.setState({
                        showRequest: !this.state.showRequest,
                        showNotification: false,
                      });
                    })}
                    <div className="cart-count adjust2">
                      {this.props.themeContext.Request.length}
                    </div>
                    {this.state.showRequest && (
                      <div
                        className="notification_wrapper"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <h3 className="header">Manufacturer Requests</h3>
                        <div style={{ marginTop: "0.5vw" }}>
                          <Scroller autoHeightMax="12vw">
                            {this.props.themeContext.Request.map(
                              (item, idx) => (
                                <ManufacturerRequestCard
                                  key={item.full_name}
                                  name={item.full_name}
                                  company={item.company_name}
                                  time={item.created}
                                  onAcceptClick={() => {
                                    this.postRequest("accepted", item.username);
                                  }}
                                  onRejectClick={() => {
                                    this.postRequest("rejected", item.username);
                                  }}
                                  onHover
                                  message={item.message}
                                  id={"message_" + idx}
                                />
                              )
                            )}
                          </Scroller>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div
                  className="nav_notification_info"
                  style={{ margin: "0 1vw" }}
                >
                  {notificationIcon((e) => {
                    e.stopPropagation();
                    this.setState({
                      showRequest: false,
                      showNotification: !this.state.showNotification,
                    });
                  })}
                  <div className="cart-count adjust">
                    {this.props.themeContext.Notification?.length}
                  </div>
                  {this.state.showNotification && (
                    <div
                      className="notification_wrapper"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <h3 className="header">Latest Notifications</h3>
                      <div style={{ marginTop: "1vw" }}>
                        <Scroller autoHeightMax="11vw">
                          {this.props.themeContext.Notification?.length > 0 ? (
                            this.renderNotification()
                          ) : (
                            <p className="no_notification">
                              No New Notification
                            </p>
                          )}
                          {}
                        </Scroller>
                      </div>
                    </div>
                  )}
                </div>
                {this.state.theme === "Light" ? (
                  <div className="nav_cart_info" onClick={this.changeTheme}>
                    {lightThemeIcone()}
                  </div>
                ) : (
                  <div className="nav_cart_info" onClick={this.changeTheme}>
                    {darkThemeIcon()}
                  </div>
                )}
                <div className="profile_wrapper">
                  <div className="profile_holder">
                    <img
                      className="no_profile"
                      src={
                        encryptStorage.getItem("UID")?.profile_pic
                          ? encryptStorage.getItem("UID")?.profile_pic
                          : logo
                      }
                    />
                    {/* <img className="no_profile" src={logo} /> */}
                  </div>
                  <div className="profile_text_holder">
                    <p className="nav_welcome">Welcome Back!</p>
                    <p className="nav_username">
                      {this.ldata?.username
                        ? this.ldata.username
                        : this.props.themeContext.Role.username}
                    </p>
                    <p className="nav_current_role">
                      {this.props.themeContext.Role.current}
                    </p>
                    <svg
                      onClick={() =>
                        this.setState({
                          showOptionList: !this.state.showOptionList,
                        })
                      }
                      className={
                        this.state.showOptionList
                          ? "nav_drop navbar_invert"
                          : "nav_drop"
                      }
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.424"
                      height="11.054"
                      viewBox="0 0 18.424 11.054"
                    >
                      <path
                        id="Vector_4394"
                        data-name="Vector 4394"
                        d="M0,0,9.212,11.054,18.424,0Z"
                        fill={this.state.theme === "Light" ? "#414d66" : "#fff"}
                      />
                    </svg>
                    <div
                      className={`profile_dropdown ${
                        showOptionList ? "active__" : "inactive"
                      }`}
                    >
                      <div
                        className="dd_head"
                        style={{
                          cursor: "no-drop",
                        }}
                        // onClick={(e) => e.stopPropagation()}
                      >
                        {this.props?.themeContext?.Role?.current}
                      </div>
                      <Link to="/profile">
                        <div className="dd_option">Profile</div>
                      </Link>
                      {this.ldata?.current === "user" && (
                        <Link to="/order">
                          <div className="dd_option">My Orders</div>
                        </Link>
                      )}
                      <div className="dd_option" onClick={this.logout}>
                        Logout
                      </div>
                      {this.props.themeContext.Role.all?.map((item) => {
                        if (
                          item !== this.props.themeContext.Role.current
                          // &&
                          // !this.props.themeContext.Role.suspended.includes(item)
                        ) {
                          return (
                            <div
                              className="dd_head"
                              onClick={() => this.switchRole(item)}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {item}
                            </div>
                          );
                        }
                        return null;
                      })}
                      {/* <div className="dd_option">Field 2</div> */}
                      {/* {userType.includes("manufacturer") && (
                        <div className="manu_user">
                          <div
                            className="dd_head acc-toggle"
                            onClick={(e) => e.stopPropagation()}
                          >
                            Manufacturer
                          </div>
                          <div className="accordion-content">
                            <Link to="/device">
                              <div className="dd_option">Device</div>
                            </Link>
                            <div className="dd_option">Field 2</div>
                          </div>
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              </div>
            </header>
          </div>
          <div
            className="__wrapper__"
            onClick={() => {
              if (this.state.showNotification || this.state.showRequest) {
                this.setState({ showNotification: false, showRequest: false });
              }
            }}
          >
            <div className="side_nav_">
              <div className="navbar_verticle">
                {userRoleLink[this.props.themeContext?.Role?.current]?.map(
                  (item) =>
                    // this.renderLink(item)
                    item === "users" &&
                    this.props.themeContext?.Role?.current === "manufacturer"
                      ? this.renderLink("mgf")
                      : this.renderLink(item)
                )}
                {/* {this.state.links.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.page}
                    activeClassName="activated_tab"
                    onClick={() => {
                    }}
                  >
                    <div className="navbar_verticle_tab">
                      {item.icon}
                      <span className="navbar_verticle_name">{item.name}</span>
                    </div>
                  </NavLink>
                ))} */}
              </div>
              <Link to="/privacy" className="privacy">
                Privacy Policy
              </Link>
              <Link to="/tos" className="privacy terms">
                Terms & Conditions
              </Link>
            </div>
            {!this.props.sidenav && <div className="side_notification_"></div>}
            <div className="body_section">
              <Scrollbars
                autoHeight
                autoHeightMax="88.4vh"
                autoHeightMin="88.4vh"
                style={{ zIndex: "10" }}
                ref={(c) => {
                  this.myRef = c;
                }}
              >
                {this.props.children}
              </Scrollbars>
            </div>
          </div>
        </div>

        {LoadingScreen && (
          <Loading type={"transparent"} text={"Authenticating"} />
        )}
        <ManufacturerModal
          ManufModal={MessageModal}
          setManufModal={() => this.setState({ MessageModal: false })}
          setLoadingScreen={(value) => this.setState({ LoadingScreen: value })}
          handleAlert={(bool, data) => {
            this.props.themeContext.getNotification();
            notify({
              type: data.type === "alert" ? "error" : "success",
              msg: data.errorText,
            });
          }}
          setShowAlert={() => {}}
          newURL="user/invite/manufacturer/accept"
        />
      </React.Fragment>
    );
  }
}

function Navbar({
  handleThemeChange,
  search,
  children,
  sidenav,
  handleScroll = null,
}) {
  const themeContext = useContext(ThemeContext);
  const history = useHistory();
  return (
    <ChildComp
      themeContext={themeContext}
      handleThemeChange={handleThemeChange}
      search={search}
      children={children}
      sidenav={sidenav}
      history={history}
      handleScroll={handleScroll}
    />
  );
}

export default withRouter(Navbar);

const homeicon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={29}
    viewBox="-4 6 55 38"
    // className="verticleicon"
  >
    <g id="_x33_3-Home" transform="translate(-8.253 -7.401)">
      <g id="Group_16009" data-name="Group 16009">
        <path
          id="Path_134010"
          data-name="Path 134010"
          d="M32.71,13.3a1.008,1.008,0,0,0-1.42,0L15.45,29.139a.99.99,0,0,0-.29.71V55.6a1,1,0,0,0,1,1h9.89V39.749a1,1,0,0,1,1-1h9.9a1,1,0,0,1,1,1V56.6h9.89a1,1,0,0,0,1-1V29.849a.99.99,0,0,0-.29-.71Z"
          fill="#424e68"
        />
        <path
          id="Path_134011"
          fill="#424e68"
          data-name="Path 134011"
          d="M54.866,29.852l-8.373-8.373V11.77a1,1,0,0,0-1-1H39.551a1,1,0,0,0-1,1v1.767L32.707,7.694a1,1,0,0,0-1.414,0L9.134,29.852a2.981,2.981,0,0,0,2.107,5.089H13.16V29.849a2.982,2.982,0,0,1,.876-2.124l15.84-15.84a3.008,3.008,0,0,1,4.247,0L49.964,27.725a2.984,2.984,0,0,1,.876,2.124v5.092h1.919a2.981,2.981,0,0,0,2.107-5.089Z"
        />
      </g>
    </g>
  </svg>
  // <svg
  //   id="dashboard_1"
  //   data-name="dashboard 1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   xmlnsXlink="http://www.w3.org/1999/xlink"
  //   width={30.461}
  //   height={30.461}
  //   viewBox="0 0 30.461 30.461"
  //   className="verticleicon"
  // >
  //   <path
  //     id="Vector"
  //     d="M11.74,0H2.221A2.223,2.223,0,0,0,0,2.221V7.932a2.224,2.224,0,0,0,2.221,2.221H11.74a2.224,2.224,0,0,0,2.221-2.221V2.221A2.224,2.224,0,0,0,11.74,0Z"
  //     fill="#424e68"
  //   />
  //   <path
  //     id="Vector-2"
  //     data-name="Vector"
  //     d="M11.74,0H2.221A2.224,2.224,0,0,0,0,2.221V15.548a2.223,2.223,0,0,0,2.221,2.221H11.74a2.224,2.224,0,0,0,2.221-2.221V2.221A2.224,2.224,0,0,0,11.74,0Z"
  //     transform="translate(0 12.692)"
  //     fill="#424e68"
  //   />
  //   <path
  //     id="Vector-3"
  //     data-name="Vector"
  //     d="M11.74,0H2.221A2.224,2.224,0,0,0,0,2.221V7.933a2.224,2.224,0,0,0,2.221,2.221H11.74a2.223,2.223,0,0,0,2.221-2.221V2.221A2.224,2.224,0,0,0,11.74,0Z"
  //     transform="translate(16.5 20.307)"
  //     fill="#424e68"
  //   />
  //   <path
  //     id="Vector-4"
  //     data-name="Vector"
  //     d="M11.74,0H2.221A2.224,2.224,0,0,0,0,2.221V15.548a2.224,2.224,0,0,0,2.221,2.221H11.74a2.224,2.224,0,0,0,2.221-2.221V2.221A2.223,2.223,0,0,0,11.74,0Z"
  //     transform="translate(16.5)"
  //     fill="#424e68"
  //   />
  // </svg>
);

const cartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52.14"
    height="42.39"
    viewBox="0 0 52.14 42.39"
    style={{ cursor: "pointer" }}
    className="nav_cart_icon"
  >
    <defs>
      <linearGradient
        id="cart-gradient"
        x1="0.5"
        y1="1.25"
        x2="0.5"
        y2="-0.25"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#2f3a4f" />
        <stop offset="0.047" stopColor="#2f3a4f" />
        <stop offset="0.089" stopColor="#313c52" />
        <stop offset="0.75" stopColor="#4e5c79" />
        <stop offset="0.759" stopColor="#4e5c7a" />
        <stop offset="1" stopColor="#4e5c79" />
      </linearGradient>
      <filter
        id="_2"
        x="0"
        y="0"
        width="52.14"
        height="42.39"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="2" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="2.5" result="blur" />
        <feFlood floodOpacity="0.149" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#_2)">
      <path
        id="_2-2"
        data-name="2"
        d="M-23.846,21.39A3.615,3.615,0,0,1-27.5,17.822c0-.078,0-.158.01-.244h-5.764c.007.1.009.175.009.244a3.615,3.615,0,0,1-3.651,3.568,3.615,3.615,0,0,1-3.651-3.568,3.416,3.416,0,0,1,.029-.44,2.117,2.117,0,0,1-1.211-1.522L-45.515-.374-50.482-1.88A2.128,2.128,0,0,1-51.76-2.928,2.054,2.054,0,0,1-51.9-4.517,2.141,2.141,0,0,1-49.844-6a2.2,2.2,0,0,1,.639.1l6.2,1.88a2.121,2.121,0,0,1,1.479,1.614l.235,1.2h24.273a2.169,2.169,0,0,1,1.659.761,2.065,2.065,0,0,1,.46,1.734l-3.45,14.579a2.125,2.125,0,0,1-1.858,1.7c.007.09.011.178.011.261A3.615,3.615,0,0,1-23.846,21.39Zm0-5.306a1.76,1.76,0,0,0-1.778,1.738,1.76,1.76,0,0,0,1.778,1.738,1.76,1.76,0,0,0,1.778-1.738A1.76,1.76,0,0,0-23.846,16.084Zm-13.048,0a1.76,1.76,0,0,0-1.778,1.738,1.76,1.76,0,0,0,1.778,1.738,1.76,1.76,0,0,0,1.778-1.738A1.76,1.76,0,0,0-36.895,16.084ZM-37.369,9.8a1.281,1.281,0,0,0-1.293,1.265,1.28,1.28,0,0,0,1.293,1.264h14.776A1.28,1.28,0,0,0-21.3,11.066,1.281,1.281,0,0,0-22.593,9.8Zm0-6.742a1.281,1.281,0,0,0-1.293,1.264,1.28,1.28,0,0,0,1.293,1.264h14.776A1.28,1.28,0,0,0-21.3,4.325,1.281,1.281,0,0,0-22.593,3.06Z"
        transform="translate(59.5 11.5)"
        fill="url(#cart-gradient)"
      />
    </g>
  </svg>
);

const notificationIcon = (onClick) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.377"
    height="40.39"
    viewBox="0 0 26.377 30.161"
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <path
      id="Forma_1"
      data-name="Forma 1"
      d="M9.127,26.67h8.122a4.108,4.108,0,0,1-8.122,0Zm8.751-1.164H0V22.971c3.249-.712,5.715-7.287,5.715-15.553a7.474,7.474,0,0,1,14.947,0c0,8.266,2.467,14.842,5.715,15.553v2.535Z"
      fill="#424e68"
    />
  </svg>
);

const lightThemeIcone = () => (
  <svg
    width="52.377"
    height="35.39"
    viewBox="0 0 24 24"
    style={{ cursor: "pointer" }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.807A9.002 9.002 0 0 1 10.049 2a9.942 9.942 0 0 0-5.12 2.735c-3.905 3.905-3.905 10.237 0 14.142 3.906 3.906 10.237 3.905 14.143 0a9.946 9.946 0 0 0 2.735-5.119A9.003 9.003 0 0 1 12 11.807z"
      fill="#424e68"
    />
  </svg>
);

const darkThemeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52.95"
    height="35.95"
    viewBox="0 0 32.95 32.95"
    style={{ cursor: "pointer" }}
  >
    <defs>
      <linearGradient
        id="dark-gradient"
        x1="0.5"
        x2="0.5"
        y2="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#424e68" />
        <stop offset="0.05" stopColor="#2f3a4f" />
        <stop offset="0.109" stopColor="#313c52" />
        <stop offset="0.594" stopColor="#4e5c79" />
        <stop offset="0.632" stopColor="#4e5c79" />
        <stop offset="1" stopColor="#4e5c79" />
      </linearGradient>
    </defs>
    <path
      id="path"
      d="M633.793,675.7V678.7H629.3V675.7Zm4.194-8.576-2.1,2.106-2.7-2.708,2.1-2.106Zm-4.793,20.763,2.7-2.708,2.1,2.107-2.7,2.708Zm6.29-17a8.6,8.6,0,0,1,6.291-2.708,8.366,8.366,0,0,1,6.291,2.708,9.31,9.31,0,0,1,2.7,6.319,8.441,8.441,0,0,1-2.7,6.319,9.227,9.227,0,0,1-6.291,2.708,8.366,8.366,0,0,1-6.291-2.708,9.31,9.31,0,0,1-2.7-6.319A8.441,8.441,0,0,1,639.484,670.881Zm7.788-10.081v4.514h-3V660.8Zm-3,32.95v-4.514h3v4.514Zm14.228-27.082-2.7,2.708-2.1-2.106,2.7-2.708Zm-4.793,20.613,2.1-2.107,2.7,2.708-2.1,2.106Zm4.044-11.585h4.493V678.7h-4.493Z"
      transform="translate(-629.3 -660.8)"
      fill="url(#dark-gradient)"
    />
  </svg>
);

// const deviceIcon = () => (
//   <svg
//     id="pie-chart_1"
//     data-name="pie-chart 1"
//     xmlns="http://www.w3.org/2000/svg"
//     xmlnsXlink="http://www.w3.org/1999/xlink"
//     width="30.461"
//     height="30.461"
//     viewBox="0 0 30.06 30.059"
//     className="verticleicon"
//   >
//     <g id="Group" transform="translate(15.969)">
//       <g id="Group-2" data-name="Group">
//         <path
//           id="Vector"
//           d="M.881,0A.88.88,0,0,0,0,.881V13.268a.88.88,0,0,0,.881.881H13.21a.88.88,0,0,0,.881-.881A13.274,13.274,0,0,0,.881,0Z"
//           fill="#424e68"
//         />
//       </g>
//     </g>
//     <g id="Group-3" data-name="Group" transform="translate(0 3.581)">
//       <g id="Group-4" data-name="Group">
//         <path
//           id="Vector-2"
//           data-name="Vector"
//           d="M18.481,24.5,14.208,13.05V.881A.88.88,0,0,0,13.327,0,13.325,13.325,0,0,0,0,13.21,13.375,13.375,0,0,0,13.327,26.478a13.146,13.146,0,0,0,4.639-.84A.882.882,0,0,0,18.481,24.5Z"
//           fill="#424e68"
//         />
//       </g>
//     </g>
//     <g id="Group-5" data-name="Group" transform="translate(15.969 15.03)">
//       <g id="Group-6" data-name="Group" transform="translate(0)">
//         <path
//           id="Vector-3"
//           data-name="Vector"
//           d="M13.21,0H.881A.881.881,0,0,0,.056,1.19l4.329,11.6a.882.882,0,0,0,1.135.514A13.362,13.362,0,0,0,14.091.881.88.88,0,0,0,13.21,0Z"
//           transform="translate(0)"
//           fill="#424e68"
//         />
//       </g>
//     </g>
//   </svg>
// );

const userIcon = () => (
  <svg
    id="customer_1"
    data-name="customer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={25}
    height={28}
    viewBox="0 0 30.06 26.228"
    className="verticleicon"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M10.216,5.108A5.108,5.108,0,1,1,5.108,0,5.108,5.108,0,0,1,10.216,5.108Z"
        transform="translate(9.922)"
        fill="#424e68"
      />
      <path
        id="Vector-2"
        data-name="Vector"
        d="M6.458,3.229A3.229,3.229,0,1,1,3.229,0,3.229,3.229,0,0,1,6.458,3.229Z"
        transform="translate(22.134 3.757)"
        fill="#424e68"
      />
      <path
        id="Vector-3"
        data-name="Vector"
        d="M6.458,3.229A3.229,3.229,0,1,1,3.229,0,3.229,3.229,0,0,1,6.458,3.229Z"
        transform="translate(1.468 3.757)"
        fill="#424e68"
      />
      <path
        id="Vector-4"
        data-name="Vector"
        d="M7.878.91C6.607-.132,5.456.006,3.986.006A3.979,3.979,0,0,0,0,3.968V10.38A1.725,1.725,0,0,0,1.727,12.1c4.111,0,3.616.074,3.616-.177C5.343,7.38,4.8,4.048,7.878.91Z"
        transform="translate(0 12.206)"
        fill="#424e68"
      />
      <path
        id="Vector-5"
        data-name="Vector"
        d="M9.372.069C6.8-.145,4.573.072,2.649,1.66c-3.221,2.58-2.6,6.053-2.6,10.3A2.06,2.06,0,0,0,2.1,14.019c12.393,0,12.886.4,13.621-1.228.241-.55.175-.375.175-5.64A7.118,7.118,0,0,0,9.372.069Z"
        transform="translate(7.056 12.166)"
        fill="#424e68"
      />
      <path
        id="Vector-6"
        data-name="Vector"
        d="M3.892.006C2.414.006,1.269-.131,0,.909,3.051,4.024,2.536,7.129,2.536,11.923c0,.253-.411.177,3.554.177a1.787,1.787,0,0,0,1.788-1.781V3.968A3.979,3.979,0,0,0,3.892.006Z"
        transform="translate(22.181 12.206)"
        fill="#424e68"
      />
    </g>
  </svg>
);
const requestIcon = (onClick) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={27.752}
    height={27.752}
    viewBox="0 0 27.752 27.752"
    onClick={onClick}
    style={{ cursor: "pointer" }}
  >
    <defs>
      <linearGradient
        id="request-gradient"
        x1={0.5}
        x2={0.5}
        y2={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="#4e5c79" />
        <stop offset={0.367} stopColor="#4e5c7a" />
        <stop offset={0.414} stopColor="#4e5c79" />
        <stop offset={0.822} stopColor="#313c52" />
        <stop offset={0.917} stopColor="#2f3a4f" />
        <stop offset={1} stopColor="#2f3a4f" />
      </linearGradient>
    </defs>
    <path
      id="svgviewer-output_1_"
      data-name="svgviewer-output (1)"
      d="M13.876,15.876A6.938,6.938,0,1,0,6.938,8.938,6.938,6.938,0,0,0,13.876,15.876ZM2.313,29.752A2.265,2.265,0,0,1,0,27.439c0-2.313,2.313-9.251,13.876-9.251s13.876,6.938,13.876,9.251a2.265,2.265,0,0,1-2.313,2.313Z"
      transform="translate(0 -2)"
      fill="url(#request-gradient)"
    />
  </svg>
);
const bellIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    role="img"
  >
    <g id="Group_91" data-name="Group 91" transform="translate(-487 -1563)">
      <g
        id="Ellipse_359"
        data-name="Ellipse 359"
        transform="translate(487 1563)"
        fill="rgba(45,206,152,0.3)"
        stroke="#2dce98"
        strokeWidth={1}
      >
        <circle cx={20} cy={20} r={20} stroke="none" />
        <circle cx={20} cy={20} r={19.5} fill="none" />
      </g>
      <g id="bell" transform="translate(498 1573)">
        <path
          id="Path_447"
          data-name="Path 447"
          d="M18,8A6,6,0,0,0,6,8c0,7-3,9-3,9H21s-3-2-3-9"
          transform="translate(-3 -2)"
          fill="none"
          stroke="#2dce98"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <path
          id="Path_448"
          data-name="Path 448"
          d="M13.73,21a2,2,0,0,1-3.46,0"
          transform="translate(-3 -2)"
          fill="none"
          stroke="#2dce98"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);

const emailIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    role="img"
  >
    <g id="Group_92" data-name="Group 92" transform="translate(-487 -1563)">
      <g
        id="Ellipse_359"
        data-name="Ellipse 359"
        transform="translate(487 1563)"
        fill="rgba(245,60,86,0.3)"
        stroke="#f53c56"
        strokeWidth={1}
      >
        <circle cx={20} cy={20} r={20} stroke="none" />
        <circle cx={20} cy={20} r={19.5} fill="none" />
      </g>
      <g id="mail" transform="translate(497 1575)">
        <path
          id="Path_437"
          data-name="Path 437"
          d="M4,4H20a2.006,2.006,0,0,1,2,2V18a2.006,2.006,0,0,1-2,2H4a2.006,2.006,0,0,1-2-2V6A2.006,2.006,0,0,1,4,4Z"
          transform="translate(-2 -4)"
          fill="none"
          stroke="#f53c56"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <path
          id="Path_438"
          data-name="Path 438"
          d="M22,6,12,13,2,6"
          transform="translate(-2 -4)"
          fill="none"
          stroke="#f53c56"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);

const starIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    role="img"
  >
    <g id="Group_93" data-name="Group 93" transform="translate(-487 -1563)">
      <g
        id="Ellipse_359"
        data-name="Ellipse 359"
        transform="translate(487 1563)"
        fill="rgba(254,185,105,0.3)"
        stroke="#feb969"
        strokeWidth={1}
      >
        <circle cx={20} cy={20} r={20} stroke="none" />
        <circle cx={20} cy={20} r={19.5} fill="none" />
      </g>
      <g id="star" transform="translate(497 1573)">
        <path
          id="star-2"
          data-name="star"
          d="M12,2l3.09,6.26L22,9.27l-5,4.87,1.18,6.88L12,17.77,5.82,21.02,7,14.14,2,9.27,8.91,8.26Z"
          transform="translate(-2 -2)"
          fill="none"
          stroke="#feb969"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </g>
    </g>
  </svg>
);

const requestIcon2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    className="requestIcon2"
  >
    <g
      id="Group_15637"
      data-name="Group 15637"
      transform="translate(-1300 -181)"
    >
      <g id="Group_91" data-name="Group 91" transform="translate(813 -1382)">
        <g
          id="Ellipse_359"
          data-name="Ellipse 359"
          transform="translate(487 1563)"
          fill="rgba(235,104,65,0.3)"
          stroke="#eb6841"
          strokeWidth={1}
        >
          <circle cx={20} cy={20} r={20} stroke="none" />
          <circle cx={20} cy={20} r={19.5} fill="none" />
        </g>
      </g>
      <path
        id="svgviewer-output_2_"
        data-name="svgviewer-output (2)"
        d="M2.5,7H0V9.667H2.5v2.667H5V9.667h2.5V7H5V4.333H2.5Zm8.757,0a3.882,3.882,0,0,1,3.753-4,3.882,3.882,0,0,1,3.753,4V9.667a3.882,3.882,0,0,1-3.753,4,3.882,3.882,0,0,1-3.753-4ZM25.021,19.187A18.979,18.979,0,0,0,5,19.187V23H25.021Z"
        transform="translate(1308 188)"
        fill="#eb6841"
      />
    </g>
  </svg>
);
const deviceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={28}
    viewBox="0 0 17 14"
  >
    <path
      id="edge_device_icon_149941"
      d="M16,7.5h2a.5.5,0,0,1,0,1H16a.5.5,0,0,1,0-1Zm-9,8H9a.5.5,0,0,1,0,1H7a.5.5,0,0,1,0-1ZM5.5,6a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5Zm0-1h14A1.5,1.5,0,0,1,21,6.5v3A1.5,1.5,0,0,1,19.5,11H5.5A1.5,1.5,0,0,1,4,9.5v-3A1.5,1.5,0,0,1,5.5,5Zm0,9a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5Zm0-1h14A1.5,1.5,0,0,1,21,14.5v3A1.5,1.5,0,0,1,19.5,19H5.5A1.5,1.5,0,0,1,4,17.5v-3A1.5,1.5,0,0,1,5.5,13Z"
      transform="translate(-4 -5)"
      fill="#424e68"
    />
  </svg>
);

const inventoryIcon = () => (
  <svg
    fill="#424e68"
    width={30}
    height={28}
    viewBox="0 0 36 36"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>{"blocks-group-solid"}</title>
    <path
      d="M33.53,18.76,26.6,15.57V6.43A1,1,0,0,0,26,5.53l-7.5-3.45a1,1,0,0,0-.84,0l-7.5,3.45a1,1,0,0,0-.58.91v9.14L2.68,18.76a1,1,0,0,0-.58.91v9.78h0a1,1,0,0,0,.58.91l7.5,3.45a1,1,0,0,0,.84,0l7.08-3.26,7.08,3.26a1,1,0,0,0,.84,0l7.5-3.45a1,1,0,0,0,.58-.91h0V19.67A1,1,0,0,0,33.53,18.76ZM25.61,22,20.5,19.67l5.11-2.35,5.11,2.35Zm-1-6.44-6.44,3V10.87a1,1,0,0,0,.35-.08L24.6,8v7.58ZM18.1,4.08l5.11,2.35L18.1,8.78,13,6.43ZM10.6,17.31l5.11,2.35L10.6,22,5.49,19.67Zm6.5,11.49-6.5,3h0V24.11h0A1,1,0,0,0,11,24l6.08-2.8Zm15,0-6.46,3V24.11A1,1,0,0,0,26,24l6.08-2.8Z"
      className="clr-i-solid clr-i-solid-path-1"
    />
    <rect x={0} y={0} width={36} height={36} fillOpacity={0} />
  </svg>
);

const appsIcon = () => (
  <svg
    fill="#424e68"
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={28}
    viewBox="0 0 52 52"
    enableBackground="new 0 0 52 52"
    xmlSpace="preserve"
  >
    <path d="M13,4H7C5.3,4,4,5.3,4,7v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3V7C16,5.3,14.7,4,13,4z" />
    <path d="M13,36H7c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C16,37.3,14.7,36,13,36z" />
    <path d="M13,20H7c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C16,21.3,14.7,20,13,20z" />
    <path d="M29,4h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3V7C32,5.3,30.7,4,29,4z" />
    <path d="M29,36h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C32,37.3,30.7,36,29,36z" />
    <path d="M29,20h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C32,21.3,30.7,20,29,20z" />
    <path d="M45,4h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3V7C48,5.3,46.7,4,45,4z" />
    <path d="M45,36h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C48,37.3,46.7,36,45,36z" />
    <path d="M45,20h-6c-1.7,0-3,1.3-3,3v6c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3v-6C48,21.3,46.7,20,45,20z" />
    <rect x={0} y={0} width={36} height={36} fillOpacity={0} />
  </svg>
);

const licenseIcon = () => (
  <svg
    width={30}
    height={28}
    viewBox="0 0 15 15"
    fill="#424e68"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.5C0 2.67157 0.671573 2 1.5 2H13.5C14.3284 2 15 2.67157 15 3.5V11.5C15 12.3284 14.3284 13 13.5 13H1.5C0.671574 13 0 12.3284 0 11.5V3.5ZM3 6C3 4.89543 3.89543 4 5 4C6.10457 4 7 4.89543 7 6C7 7.10457 6.10457 8 5 8C3.89543 8 3 7.10457 3 6ZM12 6H9V5H12V6ZM12 9H9V8H12V9ZM5 9C3.89132 9 2.87779 9.6264 2.38197 10.618L2.05279 11.2764C1.97529 11.4314 1.98357 11.6155 2.07468 11.7629C2.16578 11.9103 2.32671 12 2.5 12H7.5C7.67329 12 7.83422 11.9103 7.92533 11.7629C8.01643 11.6155 8.02471 11.4314 7.94721 11.2764L7.61803 10.618C7.12222 9.6264 6.10869 9 5 9Z"
      fill="#424e68"
    />
  </svg>
);

const notificationData = [
  // {
  //   action_type: "message",
  //   data: "Let's meet at starbucks today, are you free?",
  //   time: "1 hr ago",
  // },
  // {
  //   action_type: "product_issue",
  //   data: "A new issue has been reported, would you be able to help me Hurray! You've got a new rating.",
  //   time: "2hrs ago",
  // },
  // {
  //   action_type: "rating",
  //   data: "Hurray! You've got a new rating.",
  //   time: "1 day ago",
  // },
  // {
  //   action_type: "product_issue",
  //   data: "Hurray! You've got a new rating.",
  //   time: "2 day ago",
  // },
  // {
  //   action_type: "rating",
  //   data: "A new issue has been reported, would you be able to help me Hurray! You've got a new rating.",
  //   time: "2hrs ago",
  // },
  {
    action_type: "manufacturer_invite",
    action_data: {
      parent_manufacturer_username: "kimss",
      parent_manufacturer_email: "mhatrepushpak00@gmail.com",
      message: "bano do bhaiya",
    },
    created: "2022-11-30T08:24:59.462000Z",
  },
];

export const ManufacturerRequestCard = ({
  name,
  time,
  company,
  message,
  onAcceptClick,
  onRejectClick,
  onHover,
  id,
}) => (
  <div
    className="manu_request_card_"
    onMouseEnter={() => {
      document.getElementById(id).style.maxHeight = "1000px";
    }}
    onMouseLeave={() => {
      document.getElementById(id).style.maxHeight = "0";
    }}
  >
    <div className="_flex">
      <p className="name">{name}</p>
      <p className="time">{timeAgo(time)}</p>
    </div>
    <p className="company">{company}</p>
    <Button name="Accept" onClick={onAcceptClick} type="gradient" />
    <Button
      name="Reject"
      onClick={onRejectClick}
      style={{
        marginLeft: "01vw",
        background: "#b9bec9",
      }}
    />
    {onHover && (
      <div id={id} className="message__">
        <p>{message}</p>
      </div>
    )}
  </div>
);

const usecaseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={29.993}
    viewBox="0 0 30 29.993"
  >
    <g
      id="_4023872-artificial-artificial-intelligence-cpu-intelligence-smart_112860"
      data-name="4023872-artificial-artificial-intelligence-cpu-intelligence-smart_112860"
      transform="translate(-60.582 -60.218)"
    >
      <g
        id="Group_16044"
        data-name="Group 16044"
        transform="translate(60.582 60.218)"
      >
        <path
          id="Path_134016"
          data-name="Path 134016"
          d="M71.065,60.218a.758.758,0,0,1,.555.228.769.769,0,0,1,.237.559v2.981h1.437V61.006a.772.772,0,0,1,.228-.559.763.763,0,0,1,.555-.228h0a.787.787,0,0,1,.792.788v2.981H76.3V61.006a.787.787,0,0,1,.792-.788.794.794,0,0,1,.8.788v2.981h1.419V61.006a.78.78,0,0,1,.237-.559.764.764,0,0,1,.555-.228h.013a.738.738,0,0,1,.546.228.765.765,0,0,1,.233.559v2.981H81.2a5.726,5.726,0,0,1,5.618,5.63v.291H89.8a.781.781,0,0,1,.56.237.745.745,0,0,1,.219.55v0a.772.772,0,0,1-.779.792H86.822v1.428H89.8a.777.777,0,0,1,.56.233.812.812,0,0,1,0,1.11.77.77,0,0,1-.56.237H86.822v1.432H89.8a.773.773,0,0,1,.56.228.746.746,0,0,1,.219.551v.013a.75.75,0,0,1-.219.555.761.761,0,0,1-.56.228H86.822v1.432H89.8a.778.778,0,0,1,.56.233.766.766,0,0,1,.219.559.75.75,0,0,1-.219.555.765.765,0,0,1-.56.233H86.822v.313a5.718,5.718,0,0,1-5.64,5.616H80.9v2.976a.781.781,0,0,1-.237.559.752.752,0,0,1-.55.228.795.795,0,0,1-.8-.787V86.447H77.887v2.976a.772.772,0,0,1-.228.559.793.793,0,0,1-.569.228.779.779,0,0,1-.783-.787V86.447H74.879v2.976a.782.782,0,0,1-.237.559.773.773,0,0,1-.56.228.787.787,0,0,1-.788-.787V86.447H71.862v2.976a.77.77,0,0,1-.224.559.783.783,0,0,1-.564.228h-.009a.737.737,0,0,1-.546-.228.768.768,0,0,1-.237-.559V86.447h-.309A5.7,5.7,0,0,1,64.36,80.9v-.38H61.379a.784.784,0,0,1-.564-.228.767.767,0,0,1-.233-.555v0a.761.761,0,0,1,.233-.555.777.777,0,0,1,.564-.237H64.36V77.51H61.379a.787.787,0,0,1-.8-.788.794.794,0,0,1,.8-.792H64.36V74.5H61.379a.779.779,0,0,1-.8-.783v-.009a.751.751,0,0,1,.233-.55.774.774,0,0,1,.564-.233H64.36V71.5H61.379a.792.792,0,0,1-.564-.237.777.777,0,0,1-.233-.559.751.751,0,0,1,.233-.55.777.777,0,0,1,.564-.237H64.36V69.6A5.705,5.705,0,0,1,69.9,63.986q.089,0,.179,0h.2V61.006a.781.781,0,0,1,.237-.559A.753.753,0,0,1,71.065,60.218Zm-2.247,9.514a2.885,2.885,0,0,0-.873,2.117,2.928,2.928,0,0,0,.215,1.132,3.02,3.02,0,0,0,.161.331,2.378,2.378,0,0,0-.242.2l-.045.049q-.037.035-.072.072a2.485,2.485,0,0,0-.242.309,2.345,2.345,0,0,0-.152.286c-.017.033-.034.066-.049.1a2.32,2.32,0,0,0-.161.882,2.43,2.43,0,0,0,.049.524,2.2,2.2,0,0,0,.448.926c.035.042.07.082.107.121q.059-.129.13-.255a3.733,3.733,0,0,1,.6-.787l0,0,.022-.022q.087-.081.175-.152a3.531,3.531,0,0,1,.461-.349q.107-.067.215-.125a.427.427,0,0,1,.049-.027,3.324,3.324,0,0,1,.492-.21l.04-.009.031-.009L70.3,74.8l.058-.018a4.026,4.026,0,0,1,.5-.085q.108-.01.215-.013t.206,0V75.94a2.377,2.377,0,0,0-2.346,2.4,2.3,2.3,0,0,0,.7,1.692,2.324,2.324,0,0,0,1.705.707,2.575,2.575,0,0,0,.591-.067v.412a1.58,1.58,0,0,0,.067.461l.013.045a1.461,1.461,0,0,0,.363.559q.047.047.1.09a1.381,1.381,0,0,0,.564.3,1.525,1.525,0,0,0,.394.054h0a1.439,1.439,0,0,0,.962-.353.27.27,0,0,0,.027-.027.8.8,0,0,0,.072-.063,1.951,1.951,0,0,0,.143-.161l.022-.027a1.487,1.487,0,0,0,.188-.362,1.549,1.549,0,0,0,.076-.336c0-.018,0-.038,0-.058v-.779H73.774V79.113h1.146v-5.93a3.534,3.534,0,0,1-.841.542,3.164,3.164,0,0,1-.331.125l-.063.022-.022,0-.027.009-.134.04-.094.018q-.066.016-.134.027l-.09.018L73.12,74l-.045,0-.031,0-.031.009h-.018q-.2.015-.4.013h-.009v-1.3h.009a2.195,2.195,0,0,0,.439-.045l.045,0,.107-.022a2.469,2.469,0,0,0,.264-.089l.045-.013a2.271,2.271,0,0,0,.394-.215q.094-.068.184-.143t.175-.157l.013-.018.058-.058a2.336,2.336,0,0,0,.448-.68c0-.014.008-.029.013-.045l.027-.085a2.336,2.336,0,0,0,.094-.4l.009-.031q.01-.1.013-.206V69.07a1.763,1.763,0,0,0-.533-1.293,1.736,1.736,0,0,0-1.285-.524h-.009a1.736,1.736,0,0,0-1.285.524,1.863,1.863,0,0,0-.407.591q-.017.046-.031.094a1.7,1.7,0,0,0-.09.416q-.169-.017-.345-.018A2.885,2.885,0,0,0,68.818,69.732Zm.918,2.094q.043-.1.094-.188a3.737,3.737,0,0,1,.667-.9v0a3.576,3.576,0,0,1,1.5-.9,3.5,3.5,0,0,1,.851-.157q.124-.007.251-.009v1.325a2.39,2.39,0,0,0-2.234,1.629q-.024.083-.045.166a2.578,2.578,0,0,0-.054.376c0,.056,0,.113,0,.17H69.418q0-.156.013-.3.015-.2.049-.389A3.455,3.455,0,0,1,69.736,71.827ZM70.3,79.4V78.074a2.385,2.385,0,0,0,2.238-1.633q.024-.08.045-.161a2.653,2.653,0,0,0,.054-.38q0-.082,0-.166h1.338q0,.156-.014.3-.015.2-.049.389a3.466,3.466,0,0,1-.255.814q-.043.1-.094.188a3.741,3.741,0,0,1-.667.9v0a3.576,3.576,0,0,1-1.5.9,3.5,3.5,0,0,1-.851.152Q70.424,79.4,70.3,79.4Zm9.458-11.032a1.866,1.866,0,0,0-.407-.591,1.736,1.736,0,0,0-1.285-.524h-.009a1.8,1.8,0,0,0-1.818,1.817v1.441q0,.1.014.206l.009.031a2.325,2.325,0,0,0,.094.4l.027.085q.007.023.013.045a2.336,2.336,0,0,0,.448.68l.058.058.013.018q.085.084.175.157t.184.143a2.272,2.272,0,0,0,.394.215l.045.013a2.482,2.482,0,0,0,.264.089l.107.022.045,0a2.195,2.195,0,0,0,.439.045h0v1.3h0q-.2,0-.4-.013h-.018l-.032-.009-.031,0-.045,0-.063-.009-.09-.018q-.068-.012-.134-.027l-.094-.018-.134-.04-.027-.009-.022,0-.063-.022a3.177,3.177,0,0,1-.331-.125,3.541,3.541,0,0,1-.842-.542v5.93h1.146v1.316H76.236v.779c0,.02,0,.04,0,.058a1.537,1.537,0,0,0,.072.336,1.505,1.505,0,0,0,.193.362l.018.027a2.049,2.049,0,0,0,.148.161.787.787,0,0,0,.072.063.228.228,0,0,0,.022.027,1.451,1.451,0,0,0,.967.353h0a1.528,1.528,0,0,0,.394-.054,1.38,1.38,0,0,0,.564-.3q.051-.042.1-.09a1.463,1.463,0,0,0,.363-.559l.013-.045a1.579,1.579,0,0,0,.067-.461v-.412a2.574,2.574,0,0,0,.591.067,2.325,2.325,0,0,0,1.706-.707,2.3,2.3,0,0,0,.7-1.692,2.377,2.377,0,0,0-2.345-2.4V74.678c.068,0,.137,0,.206,0s.143.007.215.013a4.022,4.022,0,0,1,.5.085l.058.018.107.031.031.009.04.009a3.338,3.338,0,0,1,.492.21.407.407,0,0,1,.049.027q.108.059.215.125a3.521,3.521,0,0,1,.461.349q.088.072.175.152l.022.022,0,0a3.725,3.725,0,0,1,.6.787q.071.126.13.255c.037-.039.073-.079.108-.121a2.2,2.2,0,0,0,.448-.926,2.425,2.425,0,0,0,.049-.524,2.316,2.316,0,0,0-.161-.882c-.016-.033-.032-.065-.049-.1a2.357,2.357,0,0,0-.152-.286,2.5,2.5,0,0,0-.242-.309q-.034-.036-.072-.072l-.045-.049a2.378,2.378,0,0,0-.242-.2,3.015,3.015,0,0,0,.161-.331,2.931,2.931,0,0,0,.215-1.132,2.98,2.98,0,0,0-2.99-2.99c-.117,0-.232.007-.345.018a1.713,1.713,0,0,0-.09-.416C79.775,68.43,79.765,68.4,79.754,68.367Zm-.591,1.468a3.577,3.577,0,0,1,1.5.9v0a3.739,3.739,0,0,1,.667.9q.051.093.094.188a3.464,3.464,0,0,1,.255.814q.034.189.049.389.012.148.013.3H80.4q0-.086,0-.17a2.559,2.559,0,0,0-.054-.376q-.021-.083-.045-.166a2.389,2.389,0,0,0-2.234-1.629V69.67q.127,0,.251.009A3.5,3.5,0,0,1,79.163,69.835Zm-1.97,6.2q-.012-.148-.013-.3h1.338q0,.084,0,.166a2.619,2.619,0,0,0,.054.38q.021.081.045.161a2.384,2.384,0,0,0,2.238,1.633V79.4q-.129,0-.255-.013a3.505,3.505,0,0,1-.851-.152,3.576,3.576,0,0,1-1.5-.9v0a3.742,3.742,0,0,1-.667-.9q-.051-.093-.094-.188a3.459,3.459,0,0,1-.255-.814Q77.209,76.238,77.193,76.038Z"
          transform="translate(-60.582 -60.218)"
          fill="#424e68"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);
